export default __webpack_public_path__ + "static/media/search.5232374a.svg";